import { z as e } from "zod";
//#region src/apiUrls.ts
var t = "https://product.api.myparcel.nl", n = "https://product.api.acceptance.myparcel.nl", r = e.enum(["VASCO"]).register(e.globalRegistry, { description: "The fulfilment platform." }), i = e.enum(["status"]), a = e.uuid(), o = e.enum(["ACTIVE", "INACTIVE"]).register(e.globalRegistry, { description: "The status of the product." }), s = e.string().min(1).max(50), c = e.enum(["ASC", "DESC"]).register(e.globalRegistry, { description: "The sort direction." }), l = e.record(e.string(), e.object({
	free: e.int().gte(-9007199254740991).lte(9007199254740991).register(e.globalRegistry, { description: "The amount of free stock of the product." }),
	value: e.int().gte(0).lte(9007199254740991).register(e.globalRegistry, { description: "The amount of stock of the product." })
})), u = e.object({
	id: e.uuid().register(e.globalRegistry, { description: "The ID of the product." }),
	createdAt: e.iso.datetime().register(e.globalRegistry, { description: "The datetime the product was created" }),
	name: e.string().min(1).max(250).register(e.globalRegistry, { description: "The name of the product." }),
	shopIds: e.optional(e.array(e.string().min(1).max(50)).max(500)),
	status: e.enum(["ACTIVE", "INACTIVE"]).register(e.globalRegistry, { description: "The status of the product." }),
	trackInventory: e.boolean().register(e.globalRegistry, { description: "Whether the product its inventory should be tracked." }),
	barcode: e.optional(e.string().min(6).max(24).register(e.globalRegistry, { description: "The barcode of the product." })),
	children: e.optional(e.array(e.object({
		id: e.uuid().register(e.globalRegistry, { description: "The ID of the product." }),
		quantity: e.int().gte(1).lte(1e3).register(e.globalRegistry, { description: "The quantity of the product in the parent product." })
	})).max(50)),
	containsDangerousSubstances: e.optional(e.boolean().register(e.globalRegistry, { description: "Whether the product contains dangerous substances." })),
	countryCodeOfOrigin: e.optional(e.enum(/* @__PURE__ */ "AD.AE.AF.AG.AI.AL.AM.AO.AQ.AR.AS.AT.AU.AW.AX.AZ.BA.BB.BD.BE.BF.BG.BH.BI.BJ.BL.BM.BN.BO.BQ.BR.BS.BT.BV.BW.BY.BZ.CA.CC.CD.CF.CG.CH.CI.CK.CL.CM.CN.CO.CR.CU.CV.CW.CX.CY.CZ.DE.DJ.DK.DM.DO.DZ.EC.EE.EG.EH.ER.ES.ET.FI.FJ.FK.FM.FO.FR.GA.GB.GD.GE.GF.GG.GH.GI.GL.GM.GN.GP.GQ.GR.GS.GT.GU.GW.GY.HK.HM.HN.HR.HT.HU.ID.IE.IL.IM.IN.IO.IQ.IR.IS.IT.JE.JM.JO.JP.KE.KG.KH.KI.KM.KN.KP.KR.KW.KY.KZ.LA.LB.LC.LI.LK.LR.LS.LT.LU.LV.LY.MA.MC.MD.ME.MF.MG.MH.MK.ML.MM.MN.MO.MP.MQ.MR.MS.MT.MU.MV.MW.MX.MY.MZ.NA.NC.NE.NF.NG.NI.NL.NO.NP.NR.NU.NZ.OM.PA.PE.PF.PG.PH.PK.PL.PM.PN.PR.PS.PT.PW.PY.QA.RE.RO.RS.RU.RW.SA.SB.SC.SD.SE.SG.SH.SI.SJ.SK.SL.SM.SN.SO.SR.SS.ST.SV.SX.SY.SZ.TC.TD.TF.TG.TH.TJ.TK.TL.TM.TN.TO.TR.TT.TV.TW.TZ.UA.UG.UM.US.UY.UZ.VA.VC.VE.VG.VI.VN.VU.WF.WS.XK.YE.YT.ZA.ZM.ZW".split(".")).register(e.globalRegistry, { description: "The country code of origin of the product." })),
	descriptions: e.optional(e.array(e.object({
		text: e.string().min(1).max(2500).register(e.globalRegistry, { description: "The text of one of the product descriptions." }),
		languageCode: e.string().length(2).register(e.globalRegistry, { description: "The language code (ISO 639-1) of one of the product descriptions." })
	})).min(1).max(200).register(e.globalRegistry, { description: "The descriptions of the product." })),
	dimensions: e.optional(e.object({
		height: e.object({
			value: e.int().gte(0).register(e.globalRegistry, { description: "The length value in provided unit." }),
			unit: e.enum(["cm"]).register(e.globalRegistry, { description: "The length unit of the provided value." })
		}).register(e.globalRegistry, { description: "The height of the product." }),
		length: e.object({
			value: e.int().gte(0).register(e.globalRegistry, { description: "The length value in provided unit." }),
			unit: e.enum(["cm"]).register(e.globalRegistry, { description: "The length unit of the provided value." })
		}).register(e.globalRegistry, { description: "The length of the product." }),
		weight: e.object({
			value: e.int().gte(0).register(e.globalRegistry, { description: "The weight value in provided unit." }),
			unit: e.enum(["gr", "kg"]).register(e.globalRegistry, { description: "The weight unit of the provided value." })
		}).register(e.globalRegistry, { description: "The weight of the product." }),
		width: e.object({
			value: e.int().gte(0).register(e.globalRegistry, { description: "The length value in provided unit." }),
			unit: e.enum(["cm"]).register(e.globalRegistry, { description: "The length unit of the provided value." })
		}).register(e.globalRegistry, { description: "The width of the product." })
	}).register(e.globalRegistry, { description: "The dimensions of the product." })),
	ean: e.optional(e.string().register(e.globalRegistry, { description: "The EAN of the product, either 8 or 13 characters long." })),
	fulfilmentPlatforms: e.optional(e.tuple([r]).register(e.globalRegistry, { description: "The fulfilment platforms the product is available on." })),
	hasUnlimitedShelfLife: e.optional(e.boolean().register(e.globalRegistry, { description: "Whether the product has an unlimited shelf life." })),
	hsCode: e.optional(e.string().min(6).max(10).register(e.globalRegistry, { description: "The HS code of the product." })),
	parents: e.optional(e.array(e.uuid().register(e.globalRegistry, { description: "The ID of the product." })).min(1).max(100)),
	purchasePrice: e.optional(e.object({
		currency: e.string().length(3),
		integral: e.int().gte(0).lte(9007199254740991),
		fractional: e.int().gte(0).lte(99)
	}).register(e.globalRegistry, { description: "The purchase price of the product, excluding VAT." })),
	salesChannels: e.optional(e.array(e.union([
		e.object({
			sourceId: e.string().min(1).max(250).register(e.globalRegistry, { description: "The product ID in the e-commerce platform." }),
			salesChannelId: e.string().min(1).max(50).register(e.globalRegistry, { description: "The sales channel ID of the e-commerce platform." }),
			ecommercePlatformName: e.enum(["bol"])
		}),
		e.object({
			sourceId: e.string().min(1).max(250).register(e.globalRegistry, { description: "The product ID in the e-commerce platform." }),
			salesChannelId: e.string().min(1).max(50).register(e.globalRegistry, { description: "The sales channel ID of the e-commerce platform." }),
			ecommercePlatformName: e.enum(["lightspeed"])
		}),
		e.object({
			sourceId: e.string().min(1).max(250).register(e.globalRegistry, { description: "The product ID in the e-commerce platform." }),
			salesChannelId: e.string().min(1).max(50).register(e.globalRegistry, { description: "The sales channel ID of the e-commerce platform." }),
			ecommercePlatformName: e.enum(["magento"])
		}),
		e.object({
			sourceId: e.string().min(1).max(250).register(e.globalRegistry, { description: "The product ID in the e-commerce platform." }),
			salesChannelId: e.string().min(1).max(50).register(e.globalRegistry, { description: "The sales channel ID of the e-commerce platform." }),
			ecommercePlatformName: e.enum(["presta"])
		}),
		e.object({
			sourceId: e.string().min(1).max(250).register(e.globalRegistry, { description: "The product ID in the e-commerce platform." }),
			salesChannelId: e.string().min(1).max(50).register(e.globalRegistry, { description: "The sales channel ID of the e-commerce platform." }),
			ecommercePlatformName: e.enum(["shopify"]),
			inventoryItemId: e.optional(e.string().min(1).max(250).register(e.globalRegistry, { description: "The inventory item ID in shopify." })),
			inventoryLocationId: e.optional(e.string().min(1).max(250).register(e.globalRegistry, { description: "The location id of the product in shopify" }))
		}),
		e.object({
			sourceId: e.string().min(1).max(250).register(e.globalRegistry, { description: "The product ID in the e-commerce platform." }),
			salesChannelId: e.string().min(1).max(50).register(e.globalRegistry, { description: "The sales channel ID of the e-commerce platform." }),
			ecommercePlatformName: e.enum(["woocommerce"])
		})
	])).register(e.globalRegistry, { description: "References to the sales channels per e-commerce platform." })),
	salesPrice: e.optional(e.object({
		currency: e.string().length(3),
		integral: e.int().gte(0).lte(9007199254740991),
		fractional: e.int().gte(0).lte(99),
		taxRate: e.int().gte(0).lte(100)
	}).register(e.globalRegistry, { description: "The sales price of the product, including VAT." })),
	sku: e.optional(e.string().min(1).max(200).register(e.globalRegistry, { description: "The SKU of the product." })),
	stock: e.optional(l),
	updatedAt: e.optional(e.iso.datetime().register(e.globalRegistry, { description: "The datetime the product was last updated." }))
}), d = e.object({
	type: e.enum([
		"about:blank",
		"urn:problem:client",
		"urn:problem:invalid-request-syntax",
		"urn:problem:not-found",
		"urn:problem:server",
		"urn:problem:unauthorized",
		"urn:problem:unsupported-media-type"
	]).register(e.globalRegistry, { description: "A URI reference that identifies the problem type." }),
	status: e.union([
		e.literal(400),
		e.literal(401),
		e.literal(404),
		e.literal(415),
		e.literal(500)
	]).register(e.globalRegistry, { description: "The HTTP status code generated by the origin server." }),
	title: e.string().min(1).max(100).register(e.globalRegistry, { description: "A short human-readable summary of the problem type." }),
	detail: e.string().min(1).max(5e3).register(e.globalRegistry, { description: "A human-readable explanation specific to this occurrence of the problem." }),
	instance: e.url().register(e.globalRegistry, { description: "A URI reference that identifies the specific occurrence of the problem." }),
	cause: e.optional(e.unknown().register(e.globalRegistry, { description: "The cause of this problem when debug mode is enabled." }))
}), f = d.and(e.object({
	type: e.optional(e.enum(["urn:problem:invalid-request-syntax"]).register(e.globalRegistry, { description: "A URI reference that identifies the problem type." })),
	status: e.optional(e.literal(400).register(e.globalRegistry, { description: "The HTTP status code generated by the origin server." })),
	errors: e.array(e.object({
		detail: e.string().min(1).max(5e3),
		pointer: e.string().min(1).max(200).register(e.globalRegistry, { description: "This is a JSON pointer to the request (body, parameters, ...). When an aggregate has a conflict (e.g. not allowed due to the status) this value is for bulk request on the index (/body/{index}) and for any other on root (/)." })
	})).min(1).register(e.globalRegistry, { description: "Detailed information regarding the syntactic violations." })
})), p = e.object({
	body: e.object({
		containsDangerousSubstances: e.optional(e.boolean().register(e.globalRegistry, { description: "Whether the product contains dangerous substances." })),
		hasUnlimitedShelfLife: e.optional(e.boolean().register(e.globalRegistry, { description: "Whether the product has an unlimited shelf life." })),
		name: e.string().min(1).max(250).register(e.globalRegistry, { description: "The name of the product." }),
		shopIds: e.optional(e.array(e.string().min(1).max(50)).max(500)),
		sku: e.string().min(1).max(200),
		trackInventory: e.boolean().register(e.globalRegistry, { description: "Whether the product its inventory should be tracked." }),
		barcode: e.optional(e.string().min(6).max(24).register(e.globalRegistry, { description: "The barcode of the product." })),
		children: e.optional(e.array(e.object({
			id: e.uuid().register(e.globalRegistry, { description: "The ID of the product." }),
			quantity: e.int().gte(1).lte(1e3).register(e.globalRegistry, { description: "The quantity of the product in the parent product." })
		})).max(50)),
		countryCodeOfOrigin: e.optional(e.enum(/* @__PURE__ */ "AD.AE.AF.AG.AI.AL.AM.AO.AQ.AR.AS.AT.AU.AW.AX.AZ.BA.BB.BD.BE.BF.BG.BH.BI.BJ.BL.BM.BN.BO.BQ.BR.BS.BT.BV.BW.BY.BZ.CA.CC.CD.CF.CG.CH.CI.CK.CL.CM.CN.CO.CR.CU.CV.CW.CX.CY.CZ.DE.DJ.DK.DM.DO.DZ.EC.EE.EG.EH.ER.ES.ET.FI.FJ.FK.FM.FO.FR.GA.GB.GD.GE.GF.GG.GH.GI.GL.GM.GN.GP.GQ.GR.GS.GT.GU.GW.GY.HK.HM.HN.HR.HT.HU.ID.IE.IL.IM.IN.IO.IQ.IR.IS.IT.JE.JM.JO.JP.KE.KG.KH.KI.KM.KN.KP.KR.KW.KY.KZ.LA.LB.LC.LI.LK.LR.LS.LT.LU.LV.LY.MA.MC.MD.ME.MF.MG.MH.MK.ML.MM.MN.MO.MP.MQ.MR.MS.MT.MU.MV.MW.MX.MY.MZ.NA.NC.NE.NF.NG.NI.NL.NO.NP.NR.NU.NZ.OM.PA.PE.PF.PG.PH.PK.PL.PM.PN.PR.PS.PT.PW.PY.QA.RE.RO.RS.RU.RW.SA.SB.SC.SD.SE.SG.SH.SI.SJ.SK.SL.SM.SN.SO.SR.SS.ST.SV.SX.SY.SZ.TC.TD.TF.TG.TH.TJ.TK.TL.TM.TN.TO.TR.TT.TV.TW.TZ.UA.UG.UM.US.UY.UZ.VA.VC.VE.VG.VI.VN.VU.WF.WS.XK.YE.YT.ZA.ZM.ZW".split(".")).register(e.globalRegistry, { description: "The country code of origin of the product." })),
		descriptions: e.optional(e.array(e.object({
			text: e.string().min(1).max(2500).register(e.globalRegistry, { description: "The text of one of the product descriptions." }),
			languageCode: e.string().length(2).register(e.globalRegistry, { description: "The language code (ISO 639-1) of one of the product descriptions." })
		})).min(1).max(200).register(e.globalRegistry, { description: "The descriptions of the product." })),
		dimensions: e.optional(e.object({
			height: e.object({
				value: e.int().gte(0).register(e.globalRegistry, { description: "The length value in provided unit." }),
				unit: e.enum(["cm"]).register(e.globalRegistry, { description: "The length unit of the provided value." })
			}).register(e.globalRegistry, { description: "The height of the product." }),
			length: e.object({
				value: e.int().gte(0).register(e.globalRegistry, { description: "The length value in provided unit." }),
				unit: e.enum(["cm"]).register(e.globalRegistry, { description: "The length unit of the provided value." })
			}).register(e.globalRegistry, { description: "The length of the product." }),
			weight: e.object({
				value: e.int().gte(0).register(e.globalRegistry, { description: "The weight value in provided unit." }),
				unit: e.enum(["gr", "kg"]).register(e.globalRegistry, { description: "The weight unit of the provided value." })
			}).register(e.globalRegistry, { description: "The weight of the product." }),
			width: e.object({
				value: e.int().gte(0).register(e.globalRegistry, { description: "The length value in provided unit." }),
				unit: e.enum(["cm"]).register(e.globalRegistry, { description: "The length unit of the provided value." })
			}).register(e.globalRegistry, { description: "The width of the product." })
		}).register(e.globalRegistry, { description: "The dimensions of the product." })),
		ean: e.optional(e.string().register(e.globalRegistry, { description: "The EAN of the product, either 8 or 13 characters long." })),
		fulfilmentPlatforms: e.optional(e.tuple([r])),
		hsCode: e.optional(e.string().min(6).max(10).register(e.globalRegistry, { description: "The HS code of the product." })),
		purchasePrice: e.optional(e.object({
			currency: e.string().length(3),
			integral: e.int().gte(0).lte(9007199254740991),
			fractional: e.int().gte(0).lte(99)
		}).register(e.globalRegistry, { description: "The purchase price of the product, excluding VAT." })),
		salesPrice: e.optional(e.object({
			currency: e.string().length(3),
			integral: e.int().gte(0).lte(9007199254740991),
			fractional: e.int().gte(0).lte(99),
			taxRate: e.int().gte(0).lte(100)
		}).register(e.globalRegistry, { description: "The sales price of the product, including VAT." })),
		status: e.optional(e.enum(["ACTIVE", "INACTIVE"]).register(e.globalRegistry, { description: "The status of the product." }))
	}).register(e.globalRegistry, { description: "Body for creating a product." }),
	path: e.optional(e.never()),
	query: e.optional(e.never())
}), m = u, h = e.object({
	body: e.optional(e.never()),
	path: e.optional(e.never()),
	query: e.optional(e.object({
		aggregation: e.optional(e.tuple([i]).register(e.globalRegistry, { description: "Fields to summarize data based on the query." })),
		filter: e.optional(e.object({
			id: e.optional(e.array(a).min(1).max(100)),
			createdAt: e.optional(e.array(e.string().regex(/^(?<inequalitySymbol>gt|gte|lt|lte)\s(?<datetime>\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d(?:[+-][0-2]\d:[0-5]\d|Z))$/).register(e.globalRegistry, { description: "Inequality symbol 'gt', 'gte', 'lt', 'lte' with a datetime in ISO 8601 format." })).min(1).max(2)),
			countryCodeOfOrigin: e.optional(e.array(e.enum(/* @__PURE__ */ "AD.AE.AF.AG.AI.AL.AM.AO.AQ.AR.AS.AT.AU.AW.AX.AZ.BA.BB.BD.BE.BF.BG.BH.BI.BJ.BL.BM.BN.BO.BQ.BR.BS.BT.BV.BW.BY.BZ.CA.CC.CD.CF.CG.CH.CI.CK.CL.CM.CN.CO.CR.CU.CV.CW.CX.CY.CZ.DE.DJ.DK.DM.DO.DZ.EC.EE.EG.EH.ER.ES.ET.FI.FJ.FK.FM.FO.FR.GA.GB.GD.GE.GF.GG.GH.GI.GL.GM.GN.GP.GQ.GR.GS.GT.GU.GW.GY.HK.HM.HN.HR.HT.HU.ID.IE.IL.IM.IN.IO.IQ.IR.IS.IT.JE.JM.JO.JP.KE.KG.KH.KI.KM.KN.KP.KR.KW.KY.KZ.LA.LB.LC.LI.LK.LR.LS.LT.LU.LV.LY.MA.MC.MD.ME.MF.MG.MH.MK.ML.MM.MN.MO.MP.MQ.MR.MS.MT.MU.MV.MW.MX.MY.MZ.NA.NC.NE.NF.NG.NI.NL.NO.NP.NR.NU.NZ.OM.PA.PE.PF.PG.PH.PK.PL.PM.PN.PR.PS.PT.PW.PY.QA.RE.RO.RS.RU.RW.SA.SB.SC.SD.SE.SG.SH.SI.SJ.SK.SL.SM.SN.SO.SR.SS.ST.SV.SX.SY.SZ.TC.TD.TF.TG.TH.TJ.TK.TL.TM.TN.TO.TR.TT.TV.TW.TZ.UA.UG.UM.US.UY.UZ.VA.VC.VE.VG.VI.VN.VU.WF.WS.XK.YE.YT.ZA.ZM.ZW".split(".")))),
			dangerousSubstances: e.optional(e.enum(["true", "false"]).register(e.globalRegistry, { description: "The filter on dangerous substances." })),
			dimensionsVolume: e.optional(e.array(e.string().regex(/^(?<inequalitySymbol>gt|gte|lt|lte)\s(?<number>\d{1,15}(?:.\d{0,2})?)$/).register(e.globalRegistry, { description: "Inequality symbol 'gt', 'gte', 'lt', 'lte' with a (floating) number (12, 123.45)." })).min(1).max(2)),
			salesPrice: e.optional(e.array(e.string().regex(/^(?<inequalitySymbol>gt|gte|lt|lte)\s(?<number>\d{1,15}(?:.\d{0,2})?)$/).register(e.globalRegistry, { description: "Inequality symbol 'gt', 'gte', 'lt', 'lte' with a floating number (123.45)." })).min(1).max(2)),
			shopId: e.optional(e.array(s).min(1).max(100)),
			status: e.optional(e.array(o).min(1).max(2)),
			taxRate: e.optional(e.array(e.string()).min(1).max(100)),
			unlimitedShelfLife: e.optional(e.enum(["true", "false"]).register(e.globalRegistry, { description: "The filter on unlimited shelf life." }))
		})),
		limit: e.optional(e.int().gte(1).lte(50).register(e.globalRegistry, { description: "The maximum number of products to retrieve." })).default(50),
		query: e.optional(e.string().min(1).max(500).register(e.globalRegistry, { description: "The following operators are supported:\n'+ signifies AND operation'\n'| signifies OR operation'\n'- negates a single token'\n'\" wraps a number of tokens to signify a phrase for searching'\n'* at the end of a term signifies a prefix query'\n'( and ) signify precedence'\n'~N after a word signifies edit distance (fuzziness)'\n'~N after a phrase signifies slop amount'\nTo use one of these characters literally, escape it with a preceding backslash (\\)." })),
		pageToken: e.optional(e.string().min(4).max(500).register(e.globalRegistry, { description: "The page token to retrieve the next page of orders." })),
		sort: e.optional(e.object({
			barcode: e.optional(c.and(e.unknown().register(e.globalRegistry, { description: "The sort order and direction on the barcode property." }))),
			ean: e.optional(c.and(e.unknown().register(e.globalRegistry, { description: "The sort order and direction on the ean property." }))),
			name: e.optional(c.and(e.unknown().register(e.globalRegistry, { description: "The sort order and direction on the name property." }))),
			purchasePrice: e.optional(c.and(e.unknown().register(e.globalRegistry, { description: "The sort order and direction on the purchase price property." }))),
			salesPrice: e.optional(c.and(e.unknown().register(e.globalRegistry, { description: "The sort order and direction on the sales price property." }))),
			sku: e.optional(c.and(e.unknown().register(e.globalRegistry, { description: "The sort order and direction on the sku property." }))),
			status: e.optional(c.and(e.unknown().register(e.globalRegistry, { description: "The sort order and direction on the status property." }))),
			stock: e.optional(c.and(e.unknown().register(e.globalRegistry, { description: "The sort order and direction on the stock property." })))
		}).register(e.globalRegistry, { description: "When no `query` is provided the default sort is by `name` ascending. When a `query` is provided the default sort is by relevance." }))
	}))
}), g = e.object({
	results: e.array(u).min(0).max(50).register(e.globalRegistry, { description: "The list of products." }),
	total: e.object({
		relation: e.enum(["eq", "gte"]).register(e.globalRegistry, { description: "The relation of the total number of products." }),
		value: e.int().gte(0).register(e.globalRegistry, { description: "The total number of products." })
	}),
	aggregations: e.optional(e.object({ status: e.optional(e.tuple([e.object({
		key: o,
		count: e.int().gte(0)
	}), e.object({
		key: o,
		count: e.int().gte(0)
	})])) })),
	nextPageToken: e.optional(e.string().min(1).max(500).register(e.globalRegistry, { description: "The next page token to retrieve the next page of products." }))
}).register(e.globalRegistry, { description: "The listed products." }), _ = e.object({
	body: e.object({
		productIds: e.array(e.uuid()).min(1).max(50).register(e.globalRegistry, { description: "The product ids to (un)manage inventory for." }),
		fulfilmentPlatforms: e.optional(e.tuple([e.enum(["VASCO"]).register(e.globalRegistry, { description: "The fulfilment platform." })]).register(e.globalRegistry, { description: "The fulfilment platforms to (un)manage inventory for." }))
	}).register(e.globalRegistry, { description: "Body for (un)managing inventory of a product." }),
	path: e.optional(e.never()),
	query: e.optional(e.never())
}), v = e.void().register(e.globalRegistry, { description: "inventory is (un)managed by provided fulfilment platform." }), y = e.object({
	body: e.object({
		id: e.uuid().register(e.globalRegistry, { description: "The ID of the product." }),
		containsDangerousSubstances: e.optional(e.boolean().register(e.globalRegistry, { description: "Whether the product contains dangerous substances." })),
		hasUnlimitedShelfLife: e.optional(e.boolean().register(e.globalRegistry, { description: "Whether the product has an unlimited shelf life." })),
		name: e.string().min(1).max(250).register(e.globalRegistry, { description: "The name of the product." }),
		shopIds: e.optional(e.array(e.string().min(1).max(50)).max(500)),
		sku: e.string().min(1).max(200),
		trackInventory: e.boolean().register(e.globalRegistry, { description: "Whether the product its inventory should be tracked." }),
		barcode: e.optional(e.string().min(6).max(24).register(e.globalRegistry, { description: "The barcode of the product." })),
		children: e.optional(e.array(e.object({
			id: e.uuid().register(e.globalRegistry, { description: "The ID of the product." }),
			quantity: e.int().gte(1).lte(1e3).register(e.globalRegistry, { description: "The quantity of the product in the parent product." })
		})).max(50)),
		countryCodeOfOrigin: e.optional(e.enum(/* @__PURE__ */ "AD.AE.AF.AG.AI.AL.AM.AO.AQ.AR.AS.AT.AU.AW.AX.AZ.BA.BB.BD.BE.BF.BG.BH.BI.BJ.BL.BM.BN.BO.BQ.BR.BS.BT.BV.BW.BY.BZ.CA.CC.CD.CF.CG.CH.CI.CK.CL.CM.CN.CO.CR.CU.CV.CW.CX.CY.CZ.DE.DJ.DK.DM.DO.DZ.EC.EE.EG.EH.ER.ES.ET.FI.FJ.FK.FM.FO.FR.GA.GB.GD.GE.GF.GG.GH.GI.GL.GM.GN.GP.GQ.GR.GS.GT.GU.GW.GY.HK.HM.HN.HR.HT.HU.ID.IE.IL.IM.IN.IO.IQ.IR.IS.IT.JE.JM.JO.JP.KE.KG.KH.KI.KM.KN.KP.KR.KW.KY.KZ.LA.LB.LC.LI.LK.LR.LS.LT.LU.LV.LY.MA.MC.MD.ME.MF.MG.MH.MK.ML.MM.MN.MO.MP.MQ.MR.MS.MT.MU.MV.MW.MX.MY.MZ.NA.NC.NE.NF.NG.NI.NL.NO.NP.NR.NU.NZ.OM.PA.PE.PF.PG.PH.PK.PL.PM.PN.PR.PS.PT.PW.PY.QA.RE.RO.RS.RU.RW.SA.SB.SC.SD.SE.SG.SH.SI.SJ.SK.SL.SM.SN.SO.SR.SS.ST.SV.SX.SY.SZ.TC.TD.TF.TG.TH.TJ.TK.TL.TM.TN.TO.TR.TT.TV.TW.TZ.UA.UG.UM.US.UY.UZ.VA.VC.VE.VG.VI.VN.VU.WF.WS.XK.YE.YT.ZA.ZM.ZW".split(".")).register(e.globalRegistry, { description: "The country code of origin of the product." })),
		descriptions: e.optional(e.array(e.object({
			text: e.string().min(1).max(2500).register(e.globalRegistry, { description: "The text of one of the product descriptions." }),
			languageCode: e.string().length(2).register(e.globalRegistry, { description: "The language code (ISO 639-1) of one of the product descriptions." })
		})).min(1).max(200).register(e.globalRegistry, { description: "The descriptions of the product." })),
		dimensions: e.optional(e.object({
			height: e.object({
				value: e.int().gte(0).register(e.globalRegistry, { description: "The length value in provided unit." }),
				unit: e.enum(["cm"]).register(e.globalRegistry, { description: "The length unit of the provided value." })
			}).register(e.globalRegistry, { description: "The height of the product." }),
			length: e.object({
				value: e.int().gte(0).register(e.globalRegistry, { description: "The length value in provided unit." }),
				unit: e.enum(["cm"]).register(e.globalRegistry, { description: "The length unit of the provided value." })
			}).register(e.globalRegistry, { description: "The length of the product." }),
			weight: e.object({
				value: e.int().gte(0).register(e.globalRegistry, { description: "The weight value in provided unit." }),
				unit: e.enum(["gr", "kg"]).register(e.globalRegistry, { description: "The weight unit of the provided value." })
			}).register(e.globalRegistry, { description: "The weight of the product." }),
			width: e.object({
				value: e.int().gte(0).register(e.globalRegistry, { description: "The length value in provided unit." }),
				unit: e.enum(["cm"]).register(e.globalRegistry, { description: "The length unit of the provided value." })
			}).register(e.globalRegistry, { description: "The width of the product." })
		}).register(e.globalRegistry, { description: "The dimensions of the product." })),
		ean: e.optional(e.string().register(e.globalRegistry, { description: "The EAN of the product, either 8 or 13 characters long." })),
		hsCode: e.optional(e.string().min(6).max(10).register(e.globalRegistry, { description: "The HS code of the product." })),
		purchasePrice: e.optional(e.object({
			currency: e.string().length(3),
			integral: e.int().gte(0).lte(9007199254740991),
			fractional: e.int().gte(0).lte(99)
		}).register(e.globalRegistry, { description: "The purchase price of the product, excluding VAT." })),
		salesPrice: e.optional(e.object({
			currency: e.string().length(3),
			integral: e.int().gte(0).lte(9007199254740991),
			fractional: e.int().gte(0).lte(99),
			taxRate: e.int().gte(0).lte(100)
		}).register(e.globalRegistry, { description: "The sales price of the product, including VAT." })),
		status: e.optional(e.enum(["ACTIVE", "INACTIVE"]).register(e.globalRegistry, { description: "The status of the product." }))
	}).register(e.globalRegistry, { description: "Body for updating a product." }),
	path: e.optional(e.never()),
	query: e.optional(e.never())
}), b = u, x = { bodySerializer: (e) => JSON.stringify(e, (e, t) => typeof t == "bigint" ? t.toString() : t) };
Object.entries({
	$body_: "body",
	$headers_: "headers",
	$path_: "path",
	$query_: "query"
});
//#endregion
//#region src/generated/core/serverSentEvents.gen.ts
var S = ({ onRequest: e, onSseError: t, onSseEvent: n, responseTransformer: r, responseValidator: i, sseDefaultRetryDelay: a, sseMaxRetryAttempts: o, sseMaxRetryDelay: s, sseSleepFn: c, url: l, ...u }) => {
	let d, f = c ?? ((e) => new Promise((t) => setTimeout(t, e)));
	return { stream: async function* () {
		let c = a ?? 3e3, p = 0, m = u.signal ?? new AbortController().signal;
		for (; !m.aborted;) {
			p++;
			let a = u.headers instanceof Headers ? u.headers : new Headers(u.headers);
			d !== void 0 && a.set("Last-Event-ID", d);
			try {
				let t = {
					redirect: "follow",
					...u,
					body: u.serializedBody,
					headers: a,
					signal: m
				}, o = new Request(l, t);
				e && (o = await e(l, t));
				let s = await (u.fetch ?? globalThis.fetch)(o);
				if (!s.ok) throw Error(`SSE failed: ${s.status} ${s.statusText}`);
				if (!s.body) throw Error("No body in SSE response");
				let f = s.body.pipeThrough(new TextDecoderStream()).getReader(), p = "", h = () => {
					try {
						f.cancel();
					} catch {}
				};
				m.addEventListener("abort", h);
				try {
					for (;;) {
						let { done: e, value: t } = await f.read();
						if (e) break;
						p += t;
						let a = p.split("\n\n");
						p = a.pop() ?? "";
						for (let e of a) {
							let t = e.split("\n"), a = [], o;
							for (let e of t) if (e.startsWith("data:")) a.push(e.replace(/^data:\s*/, ""));
							else if (e.startsWith("event:")) o = e.replace(/^event:\s*/, "");
							else if (e.startsWith("id:")) d = e.replace(/^id:\s*/, "");
							else if (e.startsWith("retry:")) {
								let t = Number.parseInt(e.replace(/^retry:\s*/, ""), 10);
								Number.isNaN(t) || (c = t);
							}
							let s, l = !1;
							if (a.length) {
								let e = a.join("\n");
								try {
									s = JSON.parse(e), l = !0;
								} catch {
									s = e;
								}
							}
							l && (i && await i(s), r && (s = await r(s))), n?.({
								data: s,
								event: o,
								id: d,
								retry: c
							}), a.length && (yield s);
						}
					}
				} finally {
					m.removeEventListener("abort", h), f.releaseLock();
				}
				break;
			} catch (e) {
				if (t?.(e), o !== void 0 && p >= o) break;
				await f(Math.min(c * 2 ** (p - 1), s ?? 3e4));
			}
		}
	}() };
}, C = (e) => {
	switch (e) {
		case "label": return ".";
		case "matrix": return ";";
		case "simple": return ",";
		default: return "&";
	}
}, w = (e) => {
	switch (e) {
		case "form": return ",";
		case "pipeDelimited": return "|";
		case "spaceDelimited": return "%20";
		default: return ",";
	}
}, T = (e) => {
	switch (e) {
		case "label": return ".";
		case "matrix": return ";";
		case "simple": return ",";
		default: return "&";
	}
}, E = ({ allowReserved: e, explode: t, name: n, style: r, value: i }) => {
	if (!t) {
		let t = (e ? i : i.map((e) => encodeURIComponent(e))).join(w(r));
		switch (r) {
			case "label": return `.${t}`;
			case "matrix": return `;${n}=${t}`;
			case "simple": return t;
			default: return `${n}=${t}`;
		}
	}
	let a = C(r), o = i.map((t) => r === "label" || r === "simple" ? e ? t : encodeURIComponent(t) : D({
		allowReserved: e,
		name: n,
		value: t
	})).join(a);
	return r === "label" || r === "matrix" ? a + o : o;
}, D = ({ allowReserved: e, name: t, value: n }) => {
	if (n == null) return "";
	if (typeof n == "object") throw Error("Deeply-nested arrays/objects aren’t supported. Provide your own `querySerializer()` to handle these.");
	return `${t}=${e ? n : encodeURIComponent(n)}`;
}, O = ({ allowReserved: e, explode: t, name: n, style: r, value: i, valueOnly: a }) => {
	if (i instanceof Date) return a ? i.toISOString() : `${n}=${i.toISOString()}`;
	if (r !== "deepObject" && !t) {
		let t = [];
		Object.entries(i).forEach(([n, r]) => {
			t = [
				...t,
				n,
				e ? r : encodeURIComponent(r)
			];
		});
		let a = t.join(",");
		switch (r) {
			case "form": return `${n}=${a}`;
			case "label": return `.${a}`;
			case "matrix": return `;${n}=${a}`;
			default: return a;
		}
	}
	let o = T(r), s = Object.entries(i).map(([t, i]) => D({
		allowReserved: e,
		name: r === "deepObject" ? `${n}[${t}]` : t,
		value: i
	})).join(o);
	return r === "label" || r === "matrix" ? o + s : s;
}, k = /\{[^{}]+\}/g, A = ({ path: e, url: t }) => {
	let n = t, r = t.match(k);
	if (r) for (let t of r) {
		let r = !1, i = t.substring(1, t.length - 1), a = "simple";
		i.endsWith("*") && (r = !0, i = i.substring(0, i.length - 1)), i.startsWith(".") ? (i = i.substring(1), a = "label") : i.startsWith(";") && (i = i.substring(1), a = "matrix");
		let o = e[i];
		if (o == null) continue;
		if (Array.isArray(o)) {
			n = n.replace(t, E({
				explode: r,
				name: i,
				style: a,
				value: o
			}));
			continue;
		}
		if (typeof o == "object") {
			n = n.replace(t, O({
				explode: r,
				name: i,
				style: a,
				value: o,
				valueOnly: !0
			}));
			continue;
		}
		if (a === "matrix") {
			n = n.replace(t, `;${D({
				name: i,
				value: o
			})}`);
			continue;
		}
		let s = encodeURIComponent(a === "label" ? `.${o}` : o);
		n = n.replace(t, s);
	}
	return n;
}, ee = ({ baseUrl: e, path: t, query: n, querySerializer: r, url: i }) => {
	let a = i.startsWith("/") ? i : `/${i}`, o = (e ?? "") + a;
	t && (o = A({
		path: t,
		url: o
	}));
	let s = n ? r(n) : "";
	return s.startsWith("?") && (s = s.substring(1)), s && (o += `?${s}`), o;
};
function te(e) {
	let t = e.body !== void 0;
	if (t && e.bodySerializer) return "serializedBody" in e ? e.serializedBody !== void 0 && e.serializedBody !== "" ? e.serializedBody : null : e.body === "" ? null : e.body;
	if (t) return e.body;
}
//#endregion
//#region src/generated/core/auth.gen.ts
var j = async (e, t) => {
	let n = typeof t == "function" ? await t(e) : t;
	if (n) return e.scheme === "bearer" ? `Bearer ${n}` : e.scheme === "basic" ? `Basic ${btoa(n)}` : n;
}, M = ({ allowReserved: e, array: t, object: n } = {}) => (r) => {
	let i = [];
	if (r && typeof r == "object") for (let a in r) {
		let o = r[a];
		if (o != null) if (Array.isArray(o)) {
			let n = E({
				allowReserved: e,
				explode: !0,
				name: a,
				style: "form",
				value: o,
				...t
			});
			n && i.push(n);
		} else if (typeof o == "object") {
			let t = O({
				allowReserved: e,
				explode: !0,
				name: a,
				style: "deepObject",
				value: o,
				...n
			});
			t && i.push(t);
		} else {
			let t = D({
				allowReserved: e,
				name: a,
				value: o
			});
			t && i.push(t);
		}
	}
	return i.join("&");
}, N = (e) => {
	if (!e) return "stream";
	let t = e.split(";")[0]?.trim();
	if (t) {
		if (t.startsWith("application/json") || t.endsWith("+json")) return "json";
		if (t === "multipart/form-data") return "formData";
		if ([
			"application/",
			"audio/",
			"image/",
			"video/"
		].some((e) => t.startsWith(e))) return "blob";
		if (t.startsWith("text/")) return "text";
	}
}, P = (e, t) => t ? !!(e.headers.has(t) || e.query?.[t] || e.headers.get("Cookie")?.includes(`${t}=`)) : !1, F = async ({ security: e, ...t }) => {
	for (let n of e) {
		if (P(t, n.name)) continue;
		let e = await j(n, t.auth);
		if (!e) continue;
		let r = n.name ?? "Authorization";
		switch (n.in) {
			case "query":
				t.query ||= {}, t.query[r] = e;
				break;
			case "cookie":
				t.headers.append("Cookie", `${r}=${e}`);
				break;
			default:
				t.headers.set(r, e);
				break;
		}
	}
}, I = (e) => ee({
	baseUrl: e.baseUrl,
	path: e.path,
	query: e.query,
	querySerializer: typeof e.querySerializer == "function" ? e.querySerializer : M(e.querySerializer),
	url: e.url
}), L = (e, t) => {
	let n = {
		...e,
		...t
	};
	return n.baseUrl?.endsWith("/") && (n.baseUrl = n.baseUrl.substring(0, n.baseUrl.length - 1)), n.headers = z(e.headers, t.headers), n;
}, R = (e) => {
	let t = [];
	return e.forEach((e, n) => {
		t.push([n, e]);
	}), t;
}, z = (...e) => {
	let t = new Headers();
	for (let n of e) {
		if (!n) continue;
		let e = n instanceof Headers ? R(n) : Object.entries(n);
		for (let [n, r] of e) if (r === null) t.delete(n);
		else if (Array.isArray(r)) for (let e of r) t.append(n, e);
		else r !== void 0 && t.set(n, typeof r == "object" ? JSON.stringify(r) : r);
	}
	return t;
}, B = class {
	fns = [];
	clear() {
		this.fns = [];
	}
	eject(e) {
		let t = this.getInterceptorIndex(e);
		this.fns[t] && (this.fns[t] = null);
	}
	exists(e) {
		let t = this.getInterceptorIndex(e);
		return !!this.fns[t];
	}
	getInterceptorIndex(e) {
		return typeof e == "number" ? this.fns[e] ? e : -1 : this.fns.indexOf(e);
	}
	update(e, t) {
		let n = this.getInterceptorIndex(e);
		return this.fns[n] ? (this.fns[n] = t, e) : !1;
	}
	use(e) {
		return this.fns.push(e), this.fns.length - 1;
	}
}, V = () => ({
	error: new B(),
	request: new B(),
	response: new B()
}), H = M({
	allowReserved: !1,
	array: {
		explode: !0,
		style: "form"
	},
	object: {
		explode: !0,
		style: "deepObject"
	}
}), U = { "Content-Type": "application/json" }, W = (e = {}) => ({
	...x,
	headers: U,
	parseAs: "auto",
	querySerializer: H,
	...e
}), G = ((e = {}) => {
	let t = L(W(), e), n = () => ({ ...t }), r = (e) => (t = L(t, e), n()), i = V(), a = async (e) => {
		let n = {
			...t,
			...e,
			fetch: e.fetch ?? t.fetch ?? globalThis.fetch,
			headers: z(t.headers, e.headers),
			serializedBody: void 0
		};
		return n.security && await F({
			...n,
			security: n.security
		}), n.requestValidator && await n.requestValidator(n), n.body !== void 0 && n.bodySerializer && (n.serializedBody = n.bodySerializer(n.body)), (n.body === void 0 || n.serializedBody === "") && n.headers.delete("Content-Type"), {
			opts: n,
			url: I(n)
		};
	}, o = async (e) => {
		let { opts: t, url: n } = await a(e), r = {
			redirect: "follow",
			...t,
			body: te(t)
		}, o = new Request(n, r);
		for (let e of i.request.fns) e && (o = await e(o, t));
		let s = t.fetch, c = await s(o);
		for (let e of i.response.fns) e && (c = await e(c, o, t));
		let l = {
			request: o,
			response: c
		};
		if (c.ok) {
			let e = (t.parseAs === "auto" ? N(c.headers.get("Content-Type")) : t.parseAs) ?? "json";
			if (c.status === 204 || c.headers.get("Content-Length") === "0") {
				let n;
				switch (e) {
					case "arrayBuffer":
					case "blob":
					case "text":
						n = await c[e]();
						break;
					case "formData":
						n = new FormData();
						break;
					case "stream":
						n = c.body;
						break;
					default:
						n = {};
						break;
				}
				return t.responseStyle === "data" ? n : {
					data: n,
					...l
				};
			}
			let n;
			switch (e) {
				case "arrayBuffer":
				case "blob":
				case "formData":
				case "json":
				case "text":
					n = await c[e]();
					break;
				case "stream": return t.responseStyle === "data" ? c.body : {
					data: c.body,
					...l
				};
			}
			return e === "json" && (t.responseValidator && await t.responseValidator(n), t.responseTransformer && (n = await t.responseTransformer(n))), t.responseStyle === "data" ? n : {
				data: n,
				...l
			};
		}
		let u = await c.text(), d;
		try {
			d = JSON.parse(u);
		} catch {}
		let f = d ?? u, p = f;
		for (let e of i.error.fns) e && (p = await e(f, c, o, t));
		if (p ||= {}, t.throwOnError) throw p;
		return t.responseStyle === "data" ? void 0 : {
			error: p,
			...l
		};
	}, s = (e) => (t) => o({
		...t,
		method: e
	}), c = (e) => async (t) => {
		let { opts: n, url: r } = await a(t);
		return S({
			...n,
			body: n.body,
			headers: n.headers,
			method: e,
			onRequest: async (e, t) => {
				let r = new Request(e, t);
				for (let e of i.request.fns) e && (r = await e(r, n));
				return r;
			},
			url: r
		});
	};
	return {
		buildUrl: I,
		connect: s("CONNECT"),
		delete: s("DELETE"),
		get: s("GET"),
		getConfig: n,
		head: s("HEAD"),
		interceptors: i,
		options: s("OPTIONS"),
		patch: s("PATCH"),
		post: s("POST"),
		put: s("PUT"),
		request: o,
		setConfig: r,
		sse: {
			connect: c("CONNECT"),
			delete: c("DELETE"),
			get: c("GET"),
			head: c("HEAD"),
			options: c("OPTIONS"),
			patch: c("PATCH"),
			post: c("POST"),
			put: c("PUT"),
			trace: c("TRACE")
		},
		trace: s("TRACE")
	};
})(W({
	baseUrl: "https://product.api.myparcel.nl",
	throwOnError: !0
})), K = e.union([e.enum(["VASCO"]), e.string()]).register(e.globalRegistry, { description: "The fulfilment platform." }), q = e.union([e.enum(["status"]), e.string()]), J = e.uuid(), Y = e.union([e.enum(["ACTIVE", "INACTIVE"]), e.string()]).register(e.globalRegistry, { description: "The status of the product." }), X = e.string(), Z = e.union([e.enum(["ASC", "DESC"]), e.string()]).register(e.globalRegistry, { description: "The sort direction." }), ne = e.record(e.string(), e.object({
	free: e.int().gte(-9007199254740991).lte(9007199254740991).register(e.globalRegistry, { description: "The amount of free stock of the product." }),
	value: e.int().gte(0).lte(9007199254740991).register(e.globalRegistry, { description: "The amount of stock of the product." })
})), Q = e.object({
	id: e.uuid().register(e.globalRegistry, { description: "The ID of the product." }),
	createdAt: e.iso.datetime().register(e.globalRegistry, { description: "The datetime the product was created" }),
	name: e.string().register(e.globalRegistry, { description: "The name of the product." }),
	shopIds: e.optional(e.array(e.string())),
	status: e.union([e.enum(["ACTIVE", "INACTIVE"]), e.string()]).register(e.globalRegistry, { description: "The status of the product." }),
	trackInventory: e.boolean().register(e.globalRegistry, { description: "Whether the product its inventory should be tracked." }),
	barcode: e.optional(e.string().register(e.globalRegistry, { description: "The barcode of the product." })),
	children: e.optional(e.array(e.object({
		id: e.uuid().register(e.globalRegistry, { description: "The ID of the product." }),
		quantity: e.int().gte(1).lte(1e3).register(e.globalRegistry, { description: "The quantity of the product in the parent product." })
	}))),
	containsDangerousSubstances: e.optional(e.boolean().register(e.globalRegistry, { description: "Whether the product contains dangerous substances." })),
	countryCodeOfOrigin: e.optional(e.union([e.enum(/* @__PURE__ */ "AD.AE.AF.AG.AI.AL.AM.AO.AQ.AR.AS.AT.AU.AW.AX.AZ.BA.BB.BD.BE.BF.BG.BH.BI.BJ.BL.BM.BN.BO.BQ.BR.BS.BT.BV.BW.BY.BZ.CA.CC.CD.CF.CG.CH.CI.CK.CL.CM.CN.CO.CR.CU.CV.CW.CX.CY.CZ.DE.DJ.DK.DM.DO.DZ.EC.EE.EG.EH.ER.ES.ET.FI.FJ.FK.FM.FO.FR.GA.GB.GD.GE.GF.GG.GH.GI.GL.GM.GN.GP.GQ.GR.GS.GT.GU.GW.GY.HK.HM.HN.HR.HT.HU.ID.IE.IL.IM.IN.IO.IQ.IR.IS.IT.JE.JM.JO.JP.KE.KG.KH.KI.KM.KN.KP.KR.KW.KY.KZ.LA.LB.LC.LI.LK.LR.LS.LT.LU.LV.LY.MA.MC.MD.ME.MF.MG.MH.MK.ML.MM.MN.MO.MP.MQ.MR.MS.MT.MU.MV.MW.MX.MY.MZ.NA.NC.NE.NF.NG.NI.NL.NO.NP.NR.NU.NZ.OM.PA.PE.PF.PG.PH.PK.PL.PM.PN.PR.PS.PT.PW.PY.QA.RE.RO.RS.RU.RW.SA.SB.SC.SD.SE.SG.SH.SI.SJ.SK.SL.SM.SN.SO.SR.SS.ST.SV.SX.SY.SZ.TC.TD.TF.TG.TH.TJ.TK.TL.TM.TN.TO.TR.TT.TV.TW.TZ.UA.UG.UM.US.UY.UZ.VA.VC.VE.VG.VI.VN.VU.WF.WS.XK.YE.YT.ZA.ZM.ZW".split(".")), e.string()]).register(e.globalRegistry, { description: "The country code of origin of the product." })),
	descriptions: e.optional(e.array(e.object({
		text: e.string().register(e.globalRegistry, { description: "The text of one of the product descriptions." }),
		languageCode: e.string().register(e.globalRegistry, { description: "The language code (ISO 639-1) of one of the product descriptions." })
	})).register(e.globalRegistry, { description: "The descriptions of the product." })),
	dimensions: e.optional(e.object({
		height: e.object({
			value: e.int().gte(0).register(e.globalRegistry, { description: "The length value in provided unit." }),
			unit: e.union([e.enum(["cm"]), e.string()]).register(e.globalRegistry, { description: "The length unit of the provided value." })
		}).register(e.globalRegistry, { description: "The height of the product." }),
		length: e.object({
			value: e.int().gte(0).register(e.globalRegistry, { description: "The length value in provided unit." }),
			unit: e.union([e.enum(["cm"]), e.string()]).register(e.globalRegistry, { description: "The length unit of the provided value." })
		}).register(e.globalRegistry, { description: "The length of the product." }),
		weight: e.object({
			value: e.int().gte(0).register(e.globalRegistry, { description: "The weight value in provided unit." }),
			unit: e.union([e.enum(["gr", "kg"]), e.string()]).register(e.globalRegistry, { description: "The weight unit of the provided value." })
		}).register(e.globalRegistry, { description: "The weight of the product." }),
		width: e.object({
			value: e.int().gte(0).register(e.globalRegistry, { description: "The length value in provided unit." }),
			unit: e.union([e.enum(["cm"]), e.string()]).register(e.globalRegistry, { description: "The length unit of the provided value." })
		}).register(e.globalRegistry, { description: "The width of the product." })
	}).register(e.globalRegistry, { description: "The dimensions of the product." })),
	ean: e.optional(e.string().register(e.globalRegistry, { description: "The EAN of the product, either 8 or 13 characters long." })),
	fulfilmentPlatforms: e.optional(e.array(K).register(e.globalRegistry, { description: "The fulfilment platforms the product is available on." })),
	hasUnlimitedShelfLife: e.optional(e.boolean().register(e.globalRegistry, { description: "Whether the product has an unlimited shelf life." })),
	hsCode: e.optional(e.string().register(e.globalRegistry, { description: "The HS code of the product." })),
	parents: e.optional(e.array(e.uuid().register(e.globalRegistry, { description: "The ID of the product." }))),
	purchasePrice: e.optional(e.object({
		currency: e.string(),
		integral: e.int().gte(0).lte(9007199254740991),
		fractional: e.int().gte(0).lte(99)
	}).register(e.globalRegistry, { description: "The purchase price of the product, excluding VAT." })),
	salesChannels: e.optional(e.array(e.union([
		e.object({
			sourceId: e.string().register(e.globalRegistry, { description: "The product ID in the e-commerce platform." }),
			salesChannelId: e.string().register(e.globalRegistry, { description: "The sales channel ID of the e-commerce platform." }),
			ecommercePlatformName: e.union([e.enum(["bol"]), e.string()])
		}),
		e.object({
			sourceId: e.string().register(e.globalRegistry, { description: "The product ID in the e-commerce platform." }),
			salesChannelId: e.string().register(e.globalRegistry, { description: "The sales channel ID of the e-commerce platform." }),
			ecommercePlatformName: e.union([e.enum(["lightspeed"]), e.string()])
		}),
		e.object({
			sourceId: e.string().register(e.globalRegistry, { description: "The product ID in the e-commerce platform." }),
			salesChannelId: e.string().register(e.globalRegistry, { description: "The sales channel ID of the e-commerce platform." }),
			ecommercePlatformName: e.union([e.enum(["magento"]), e.string()])
		}),
		e.object({
			sourceId: e.string().register(e.globalRegistry, { description: "The product ID in the e-commerce platform." }),
			salesChannelId: e.string().register(e.globalRegistry, { description: "The sales channel ID of the e-commerce platform." }),
			ecommercePlatformName: e.union([e.enum(["presta"]), e.string()])
		}),
		e.object({
			sourceId: e.string().register(e.globalRegistry, { description: "The product ID in the e-commerce platform." }),
			salesChannelId: e.string().register(e.globalRegistry, { description: "The sales channel ID of the e-commerce platform." }),
			ecommercePlatformName: e.union([e.enum(["shopify"]), e.string()]),
			inventoryItemId: e.optional(e.string().register(e.globalRegistry, { description: "The inventory item ID in shopify." })),
			inventoryLocationId: e.optional(e.string().register(e.globalRegistry, { description: "The location id of the product in shopify" }))
		}),
		e.object({
			sourceId: e.string().register(e.globalRegistry, { description: "The product ID in the e-commerce platform." }),
			salesChannelId: e.string().register(e.globalRegistry, { description: "The sales channel ID of the e-commerce platform." }),
			ecommercePlatformName: e.union([e.enum(["woocommerce"]), e.string()])
		})
	])).register(e.globalRegistry, { description: "References to the sales channels per e-commerce platform." })),
	salesPrice: e.optional(e.object({
		currency: e.string(),
		integral: e.int().gte(0).lte(9007199254740991),
		fractional: e.int().gte(0).lte(99),
		taxRate: e.int().gte(0).lte(100)
	}).register(e.globalRegistry, { description: "The sales price of the product, including VAT." })),
	sku: e.optional(e.string().register(e.globalRegistry, { description: "The SKU of the product." })),
	stock: e.optional(ne),
	updatedAt: e.optional(e.iso.datetime().register(e.globalRegistry, { description: "The datetime the product was last updated." }))
});
e.object({
	type: e.union([e.enum([
		"about:blank",
		"urn:problem:client",
		"urn:problem:invalid-request-syntax",
		"urn:problem:not-found",
		"urn:problem:server",
		"urn:problem:unauthorized",
		"urn:problem:unsupported-media-type"
	]), e.string()]).register(e.globalRegistry, { description: "A URI reference that identifies the problem type." }),
	status: e.union([
		e.literal(400),
		e.literal(401),
		e.literal(404),
		e.literal(415),
		e.literal(500)
	]).register(e.globalRegistry, { description: "The HTTP status code generated by the origin server." }),
	title: e.string().register(e.globalRegistry, { description: "A short human-readable summary of the problem type." }),
	detail: e.string().register(e.globalRegistry, { description: "A human-readable explanation specific to this occurrence of the problem." }),
	instance: e.url().register(e.globalRegistry, { description: "A URI reference that identifies the specific occurrence of the problem." }),
	cause: e.optional(e.unknown().register(e.globalRegistry, { description: "The cause of this problem when debug mode is enabled." }))
}).and(e.object({
	type: e.optional(e.union([e.enum(["urn:problem:invalid-request-syntax"]), e.string()]).register(e.globalRegistry, { description: "A URI reference that identifies the problem type." })),
	status: e.optional(e.literal(400).register(e.globalRegistry, { description: "The HTTP status code generated by the origin server." })),
	errors: e.array(e.object({
		detail: e.string(),
		pointer: e.string().register(e.globalRegistry, { description: "This is a JSON pointer to the request (body, parameters, ...). When an aggregate has a conflict (e.g. not allowed due to the status) this value is for bulk request on the index (/body/{index}) and for any other on root (/)." })
	})).register(e.globalRegistry, { description: "Detailed information regarding the syntactic violations." })
})), e.object({
	body: e.object({
		containsDangerousSubstances: e.optional(e.boolean().register(e.globalRegistry, { description: "Whether the product contains dangerous substances." })),
		hasUnlimitedShelfLife: e.optional(e.boolean().register(e.globalRegistry, { description: "Whether the product has an unlimited shelf life." })),
		name: e.string().register(e.globalRegistry, { description: "The name of the product." }),
		shopIds: e.optional(e.array(e.string())),
		sku: e.string(),
		trackInventory: e.boolean().register(e.globalRegistry, { description: "Whether the product its inventory should be tracked." }),
		barcode: e.optional(e.string().register(e.globalRegistry, { description: "The barcode of the product." })),
		children: e.optional(e.array(e.object({
			id: e.uuid().register(e.globalRegistry, { description: "The ID of the product." }),
			quantity: e.int().gte(1).lte(1e3).register(e.globalRegistry, { description: "The quantity of the product in the parent product." })
		}))),
		countryCodeOfOrigin: e.optional(e.union([e.enum(/* @__PURE__ */ "AD.AE.AF.AG.AI.AL.AM.AO.AQ.AR.AS.AT.AU.AW.AX.AZ.BA.BB.BD.BE.BF.BG.BH.BI.BJ.BL.BM.BN.BO.BQ.BR.BS.BT.BV.BW.BY.BZ.CA.CC.CD.CF.CG.CH.CI.CK.CL.CM.CN.CO.CR.CU.CV.CW.CX.CY.CZ.DE.DJ.DK.DM.DO.DZ.EC.EE.EG.EH.ER.ES.ET.FI.FJ.FK.FM.FO.FR.GA.GB.GD.GE.GF.GG.GH.GI.GL.GM.GN.GP.GQ.GR.GS.GT.GU.GW.GY.HK.HM.HN.HR.HT.HU.ID.IE.IL.IM.IN.IO.IQ.IR.IS.IT.JE.JM.JO.JP.KE.KG.KH.KI.KM.KN.KP.KR.KW.KY.KZ.LA.LB.LC.LI.LK.LR.LS.LT.LU.LV.LY.MA.MC.MD.ME.MF.MG.MH.MK.ML.MM.MN.MO.MP.MQ.MR.MS.MT.MU.MV.MW.MX.MY.MZ.NA.NC.NE.NF.NG.NI.NL.NO.NP.NR.NU.NZ.OM.PA.PE.PF.PG.PH.PK.PL.PM.PN.PR.PS.PT.PW.PY.QA.RE.RO.RS.RU.RW.SA.SB.SC.SD.SE.SG.SH.SI.SJ.SK.SL.SM.SN.SO.SR.SS.ST.SV.SX.SY.SZ.TC.TD.TF.TG.TH.TJ.TK.TL.TM.TN.TO.TR.TT.TV.TW.TZ.UA.UG.UM.US.UY.UZ.VA.VC.VE.VG.VI.VN.VU.WF.WS.XK.YE.YT.ZA.ZM.ZW".split(".")), e.string()]).register(e.globalRegistry, { description: "The country code of origin of the product." })),
		descriptions: e.optional(e.array(e.object({
			text: e.string().register(e.globalRegistry, { description: "The text of one of the product descriptions." }),
			languageCode: e.string().register(e.globalRegistry, { description: "The language code (ISO 639-1) of one of the product descriptions." })
		})).register(e.globalRegistry, { description: "The descriptions of the product." })),
		dimensions: e.optional(e.object({
			height: e.object({
				value: e.int().gte(0).register(e.globalRegistry, { description: "The length value in provided unit." }),
				unit: e.union([e.enum(["cm"]), e.string()]).register(e.globalRegistry, { description: "The length unit of the provided value." })
			}).register(e.globalRegistry, { description: "The height of the product." }),
			length: e.object({
				value: e.int().gte(0).register(e.globalRegistry, { description: "The length value in provided unit." }),
				unit: e.union([e.enum(["cm"]), e.string()]).register(e.globalRegistry, { description: "The length unit of the provided value." })
			}).register(e.globalRegistry, { description: "The length of the product." }),
			weight: e.object({
				value: e.int().gte(0).register(e.globalRegistry, { description: "The weight value in provided unit." }),
				unit: e.union([e.enum(["gr", "kg"]), e.string()]).register(e.globalRegistry, { description: "The weight unit of the provided value." })
			}).register(e.globalRegistry, { description: "The weight of the product." }),
			width: e.object({
				value: e.int().gte(0).register(e.globalRegistry, { description: "The length value in provided unit." }),
				unit: e.union([e.enum(["cm"]), e.string()]).register(e.globalRegistry, { description: "The length unit of the provided value." })
			}).register(e.globalRegistry, { description: "The width of the product." })
		}).register(e.globalRegistry, { description: "The dimensions of the product." })),
		ean: e.optional(e.string().register(e.globalRegistry, { description: "The EAN of the product, either 8 or 13 characters long." })),
		fulfilmentPlatforms: e.optional(e.array(K)),
		hsCode: e.optional(e.string().register(e.globalRegistry, { description: "The HS code of the product." })),
		purchasePrice: e.optional(e.object({
			currency: e.string(),
			integral: e.int().gte(0).lte(9007199254740991),
			fractional: e.int().gte(0).lte(99)
		}).register(e.globalRegistry, { description: "The purchase price of the product, excluding VAT." })),
		salesPrice: e.optional(e.object({
			currency: e.string(),
			integral: e.int().gte(0).lte(9007199254740991),
			fractional: e.int().gte(0).lte(99),
			taxRate: e.int().gte(0).lte(100)
		}).register(e.globalRegistry, { description: "The sales price of the product, including VAT." })),
		status: e.optional(e.union([e.enum(["ACTIVE", "INACTIVE"]), e.string()]).register(e.globalRegistry, { description: "The status of the product." }))
	}).register(e.globalRegistry, { description: "Body for creating a product." }),
	path: e.optional(e.never()),
	query: e.optional(e.never())
});
var re = Q;
e.object({
	body: e.optional(e.never()),
	path: e.optional(e.never()),
	query: e.optional(e.object({
		aggregation: e.optional(e.array(q).register(e.globalRegistry, { description: "Fields to summarize data based on the query." })),
		filter: e.optional(e.object({
			id: e.optional(e.array(J)),
			createdAt: e.optional(e.array(e.string().register(e.globalRegistry, { description: "Inequality symbol 'gt', 'gte', 'lt', 'lte' with a datetime in ISO 8601 format." }))),
			countryCodeOfOrigin: e.optional(e.array(e.union([e.enum(/* @__PURE__ */ "AD.AE.AF.AG.AI.AL.AM.AO.AQ.AR.AS.AT.AU.AW.AX.AZ.BA.BB.BD.BE.BF.BG.BH.BI.BJ.BL.BM.BN.BO.BQ.BR.BS.BT.BV.BW.BY.BZ.CA.CC.CD.CF.CG.CH.CI.CK.CL.CM.CN.CO.CR.CU.CV.CW.CX.CY.CZ.DE.DJ.DK.DM.DO.DZ.EC.EE.EG.EH.ER.ES.ET.FI.FJ.FK.FM.FO.FR.GA.GB.GD.GE.GF.GG.GH.GI.GL.GM.GN.GP.GQ.GR.GS.GT.GU.GW.GY.HK.HM.HN.HR.HT.HU.ID.IE.IL.IM.IN.IO.IQ.IR.IS.IT.JE.JM.JO.JP.KE.KG.KH.KI.KM.KN.KP.KR.KW.KY.KZ.LA.LB.LC.LI.LK.LR.LS.LT.LU.LV.LY.MA.MC.MD.ME.MF.MG.MH.MK.ML.MM.MN.MO.MP.MQ.MR.MS.MT.MU.MV.MW.MX.MY.MZ.NA.NC.NE.NF.NG.NI.NL.NO.NP.NR.NU.NZ.OM.PA.PE.PF.PG.PH.PK.PL.PM.PN.PR.PS.PT.PW.PY.QA.RE.RO.RS.RU.RW.SA.SB.SC.SD.SE.SG.SH.SI.SJ.SK.SL.SM.SN.SO.SR.SS.ST.SV.SX.SY.SZ.TC.TD.TF.TG.TH.TJ.TK.TL.TM.TN.TO.TR.TT.TV.TW.TZ.UA.UG.UM.US.UY.UZ.VA.VC.VE.VG.VI.VN.VU.WF.WS.XK.YE.YT.ZA.ZM.ZW".split(".")), e.string()]))),
			dangerousSubstances: e.optional(e.union([e.enum(["true", "false"]), e.string()]).register(e.globalRegistry, { description: "The filter on dangerous substances." })),
			dimensionsVolume: e.optional(e.array(e.string().register(e.globalRegistry, { description: "Inequality symbol 'gt', 'gte', 'lt', 'lte' with a (floating) number (12, 123.45)." }))),
			salesPrice: e.optional(e.array(e.string().register(e.globalRegistry, { description: "Inequality symbol 'gt', 'gte', 'lt', 'lte' with a floating number (123.45)." }))),
			shopId: e.optional(e.array(X)),
			status: e.optional(e.array(Y)),
			taxRate: e.optional(e.array(e.string())),
			unlimitedShelfLife: e.optional(e.union([e.enum(["true", "false"]), e.string()]).register(e.globalRegistry, { description: "The filter on unlimited shelf life." }))
		})),
		limit: e.optional(e.int().gte(1).lte(50).register(e.globalRegistry, { description: "The maximum number of products to retrieve." })).default(50),
		query: e.optional(e.string().register(e.globalRegistry, { description: "The following operators are supported:\n'+ signifies AND operation'\n'| signifies OR operation'\n'- negates a single token'\n'\" wraps a number of tokens to signify a phrase for searching'\n'* at the end of a term signifies a prefix query'\n'( and ) signify precedence'\n'~N after a word signifies edit distance (fuzziness)'\n'~N after a phrase signifies slop amount'\nTo use one of these characters literally, escape it with a preceding backslash (\\)." })),
		pageToken: e.optional(e.string().register(e.globalRegistry, { description: "The page token to retrieve the next page of orders." })),
		sort: e.optional(e.object({
			barcode: e.optional(Z.and(e.unknown().register(e.globalRegistry, { description: "The sort order and direction on the barcode property." }))),
			ean: e.optional(Z.and(e.unknown().register(e.globalRegistry, { description: "The sort order and direction on the ean property." }))),
			name: e.optional(Z.and(e.unknown().register(e.globalRegistry, { description: "The sort order and direction on the name property." }))),
			purchasePrice: e.optional(Z.and(e.unknown().register(e.globalRegistry, { description: "The sort order and direction on the purchase price property." }))),
			salesPrice: e.optional(Z.and(e.unknown().register(e.globalRegistry, { description: "The sort order and direction on the sales price property." }))),
			sku: e.optional(Z.and(e.unknown().register(e.globalRegistry, { description: "The sort order and direction on the sku property." }))),
			status: e.optional(Z.and(e.unknown().register(e.globalRegistry, { description: "The sort order and direction on the status property." }))),
			stock: e.optional(Z.and(e.unknown().register(e.globalRegistry, { description: "The sort order and direction on the stock property." })))
		}).register(e.globalRegistry, { description: "When no `query` is provided the default sort is by `name` ascending. When a `query` is provided the default sort is by relevance." }))
	}))
});
var ie = e.object({
	results: e.array(Q).register(e.globalRegistry, { description: "The list of products." }),
	total: e.object({
		relation: e.union([e.enum(["eq", "gte"]), e.string()]).register(e.globalRegistry, { description: "The relation of the total number of products." }),
		value: e.int().gte(0).register(e.globalRegistry, { description: "The total number of products." })
	}),
	aggregations: e.optional(e.object({ status: e.optional(e.array(e.object({
		key: Y,
		count: e.int().gte(0)
	}))) })),
	nextPageToken: e.optional(e.string().register(e.globalRegistry, { description: "The next page token to retrieve the next page of products." }))
}).register(e.globalRegistry, { description: "The listed products." });
e.object({
	body: e.object({
		productIds: e.array(e.uuid()).register(e.globalRegistry, { description: "The product ids to (un)manage inventory for." }),
		fulfilmentPlatforms: e.optional(e.array(e.union([e.enum(["VASCO"]), e.string()]).register(e.globalRegistry, { description: "The fulfilment platform." })).register(e.globalRegistry, { description: "The fulfilment platforms to (un)manage inventory for." }))
	}).register(e.globalRegistry, { description: "Body for (un)managing inventory of a product." }),
	path: e.optional(e.never()),
	query: e.optional(e.never())
});
var ae = e.void().register(e.globalRegistry, { description: "inventory is (un)managed by provided fulfilment platform." });
e.object({
	body: e.object({
		id: e.uuid().register(e.globalRegistry, { description: "The ID of the product." }),
		containsDangerousSubstances: e.optional(e.boolean().register(e.globalRegistry, { description: "Whether the product contains dangerous substances." })),
		hasUnlimitedShelfLife: e.optional(e.boolean().register(e.globalRegistry, { description: "Whether the product has an unlimited shelf life." })),
		name: e.string().register(e.globalRegistry, { description: "The name of the product." }),
		shopIds: e.optional(e.array(e.string())),
		sku: e.string(),
		trackInventory: e.boolean().register(e.globalRegistry, { description: "Whether the product its inventory should be tracked." }),
		barcode: e.optional(e.string().register(e.globalRegistry, { description: "The barcode of the product." })),
		children: e.optional(e.array(e.object({
			id: e.uuid().register(e.globalRegistry, { description: "The ID of the product." }),
			quantity: e.int().gte(1).lte(1e3).register(e.globalRegistry, { description: "The quantity of the product in the parent product." })
		}))),
		countryCodeOfOrigin: e.optional(e.union([e.enum(/* @__PURE__ */ "AD.AE.AF.AG.AI.AL.AM.AO.AQ.AR.AS.AT.AU.AW.AX.AZ.BA.BB.BD.BE.BF.BG.BH.BI.BJ.BL.BM.BN.BO.BQ.BR.BS.BT.BV.BW.BY.BZ.CA.CC.CD.CF.CG.CH.CI.CK.CL.CM.CN.CO.CR.CU.CV.CW.CX.CY.CZ.DE.DJ.DK.DM.DO.DZ.EC.EE.EG.EH.ER.ES.ET.FI.FJ.FK.FM.FO.FR.GA.GB.GD.GE.GF.GG.GH.GI.GL.GM.GN.GP.GQ.GR.GS.GT.GU.GW.GY.HK.HM.HN.HR.HT.HU.ID.IE.IL.IM.IN.IO.IQ.IR.IS.IT.JE.JM.JO.JP.KE.KG.KH.KI.KM.KN.KP.KR.KW.KY.KZ.LA.LB.LC.LI.LK.LR.LS.LT.LU.LV.LY.MA.MC.MD.ME.MF.MG.MH.MK.ML.MM.MN.MO.MP.MQ.MR.MS.MT.MU.MV.MW.MX.MY.MZ.NA.NC.NE.NF.NG.NI.NL.NO.NP.NR.NU.NZ.OM.PA.PE.PF.PG.PH.PK.PL.PM.PN.PR.PS.PT.PW.PY.QA.RE.RO.RS.RU.RW.SA.SB.SC.SD.SE.SG.SH.SI.SJ.SK.SL.SM.SN.SO.SR.SS.ST.SV.SX.SY.SZ.TC.TD.TF.TG.TH.TJ.TK.TL.TM.TN.TO.TR.TT.TV.TW.TZ.UA.UG.UM.US.UY.UZ.VA.VC.VE.VG.VI.VN.VU.WF.WS.XK.YE.YT.ZA.ZM.ZW".split(".")), e.string()]).register(e.globalRegistry, { description: "The country code of origin of the product." })),
		descriptions: e.optional(e.array(e.object({
			text: e.string().register(e.globalRegistry, { description: "The text of one of the product descriptions." }),
			languageCode: e.string().register(e.globalRegistry, { description: "The language code (ISO 639-1) of one of the product descriptions." })
		})).register(e.globalRegistry, { description: "The descriptions of the product." })),
		dimensions: e.optional(e.object({
			height: e.object({
				value: e.int().gte(0).register(e.globalRegistry, { description: "The length value in provided unit." }),
				unit: e.union([e.enum(["cm"]), e.string()]).register(e.globalRegistry, { description: "The length unit of the provided value." })
			}).register(e.globalRegistry, { description: "The height of the product." }),
			length: e.object({
				value: e.int().gte(0).register(e.globalRegistry, { description: "The length value in provided unit." }),
				unit: e.union([e.enum(["cm"]), e.string()]).register(e.globalRegistry, { description: "The length unit of the provided value." })
			}).register(e.globalRegistry, { description: "The length of the product." }),
			weight: e.object({
				value: e.int().gte(0).register(e.globalRegistry, { description: "The weight value in provided unit." }),
				unit: e.union([e.enum(["gr", "kg"]), e.string()]).register(e.globalRegistry, { description: "The weight unit of the provided value." })
			}).register(e.globalRegistry, { description: "The weight of the product." }),
			width: e.object({
				value: e.int().gte(0).register(e.globalRegistry, { description: "The length value in provided unit." }),
				unit: e.union([e.enum(["cm"]), e.string()]).register(e.globalRegistry, { description: "The length unit of the provided value." })
			}).register(e.globalRegistry, { description: "The width of the product." })
		}).register(e.globalRegistry, { description: "The dimensions of the product." })),
		ean: e.optional(e.string().register(e.globalRegistry, { description: "The EAN of the product, either 8 or 13 characters long." })),
		hsCode: e.optional(e.string().register(e.globalRegistry, { description: "The HS code of the product." })),
		purchasePrice: e.optional(e.object({
			currency: e.string(),
			integral: e.int().gte(0).lte(9007199254740991),
			fractional: e.int().gte(0).lte(99)
		}).register(e.globalRegistry, { description: "The purchase price of the product, excluding VAT." })),
		salesPrice: e.optional(e.object({
			currency: e.string(),
			integral: e.int().gte(0).lte(9007199254740991),
			fractional: e.int().gte(0).lte(99),
			taxRate: e.int().gte(0).lte(100)
		}).register(e.globalRegistry, { description: "The sales price of the product, including VAT." })),
		status: e.optional(e.union([e.enum(["ACTIVE", "INACTIVE"]), e.string()]).register(e.globalRegistry, { description: "The status of the product." }))
	}).register(e.globalRegistry, { description: "Body for updating a product." }),
	path: e.optional(e.never()),
	query: e.optional(e.never())
});
var oe = Q, $ = (e) => (e.client ?? G).post({
	requestValidator: async (e) => await p.parseAsync(e),
	responseValidator: async (e) => await re.parseAsync(e),
	security: [{
		name: "Authorization",
		type: "apiKey"
	}, {
		scheme: "bearer",
		type: "http"
	}],
	url: "/create-product",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), se = (e) => (e?.client ?? G).get({
	requestValidator: async (e) => await h.parseAsync(e),
	responseValidator: async (e) => await ie.parseAsync(e),
	security: [{
		name: "Authorization",
		type: "apiKey"
	}, {
		scheme: "bearer",
		type: "http"
	}],
	url: "/products",
	...e
}), ce = (e) => (e.client ?? G).post({
	requestValidator: async (e) => await _.parseAsync(e),
	responseValidator: async (e) => await ae.parseAsync(e),
	security: [{
		name: "Authorization",
		type: "apiKey"
	}, {
		scheme: "bearer",
		type: "http"
	}],
	url: "/manage-inventory",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), le = (e) => (e.client ?? G).post({
	requestValidator: async (e) => await y.parseAsync(e),
	responseValidator: async (e) => await oe.parseAsync(e),
	security: [{
		name: "Authorization",
		type: "apiKey"
	}, {
		scheme: "bearer",
		type: "http"
	}],
	url: "/update-product",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
});
//#endregion
export { l as C, c as S, t as T, u as _, G as a, o as b, g as c, _ as d, v as f, f as g, d as h, le as i, p as l, b as m, $ as n, r as o, y as p, ce as r, h as s, se as t, m as u, i as v, n as w, s as x, a as y };
